import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { HttpClient } from "@/services/HttpClient";
import router from "@/router";
import { routeFromNotification } from "@/helpers/notificationRouting";

interface RegisterDeviceBody {
  token: string;
  platform: string;
  appVersion?: string;
}

// Mora se poklapati s ANDROID_CHANNEL u PushDispatchService.java.
const ANDROID_CHANNEL_ID = "vomi_default";
const ANDROID_IMPORTANCE_HIGH = 4;

let initialized = false;
let lastToken: string | null = null;

export async function initPush(): Promise<void> {
  if (!Capacitor.isNativePlatform() || initialized) return;
  initialized = true;

  if (Capacitor.getPlatform() === "android") {
    await PushNotifications.createChannel({
      id: ANDROID_CHANNEL_ID,
      name: "Obavijesti",
      importance: ANDROID_IMPORTANCE_HIGH,
    }).catch(() => undefined);
  }

  let permission = await PushNotifications.checkPermissions();
  if (permission.receive === "prompt" || permission.receive === "prompt-with-rationale") {
    permission = await PushNotifications.requestPermissions();
  }
  if (permission.receive !== "granted") return;

  await PushNotifications.addListener("registration", (token) => {
    lastToken = token.value;
    void sendTokenToBackend(token.value);
  });
  await PushNotifications.addListener("registrationError", (err) => {
    console.error("FCM registracija nije uspjela", err);
  });
  await PushNotifications.addListener("pushNotificationReceived", () => undefined);
  await PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    routeFromPush((action.notification.data ?? {}) as Record<string, string>);
  });

  await PushNotifications.register();
}

async function sendTokenToBackend(token: string): Promise<void> {
  try {
    await HttpClient.post<void, RegisterDeviceBody>("/devices", {
      token,
      platform: Capacitor.getPlatform().toUpperCase(),
    });
  } catch {
    // best-effort; token se ponovno šalje na sljedeći registration event
  }
}

function routeFromPush(data: Record<string, string>): void {
  if (!data.kind) return;
  void router.push(
    routeFromNotification({
      kind: data.kind,
      action: data.action || null,
      clientEmployeeId: data.clientEmployeeId || null,
    }),
  );
}

export async function unregisterPush(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (lastToken) {
    await HttpClient.delete<void, { token: string }>("/devices", null, { token: lastToken }).catch(
      () => undefined,
    );
    lastToken = null;
  }
  await PushNotifications.removeAllListeners().catch(() => undefined);
  initialized = false;
}
